import throttle from 'lodash/throttle';

export default {

	init() {
		// nothing yet
	},

	setMapBounds(map, bounds) {
		// Make resizing smoother
		window.addEventListener('resize', throttle(function() {
			google.maps.event.trigger(map, 'resize');
      Locations.fitMapBounds(map, bounds);
    }), 200);

		// Initial position
    Locations.fitMapBounds(map, bounds);
	},

	fitMapBounds(map, bounds) {
		if(Common.isMobile()) {
			// Center of NA
			map.setCenter(new google.maps.LatLng(48.368748, -99.996078));
			map.setOptions({zoom:2});
			return
		}

		map.fitBounds(bounds);
		map.setCenter(bounds.getCenter());
	}

}
